import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { AxiosError } from 'axios';
import { eClientContactActionType } from '../../types/contacts/eClientContactActionType';
import {
  convertFromLenderUserDataToLenderUserResponse,
  convertFromLenderUserResponseArrayToLenderUserDataArray,
  ILenderUserData,
  ILenderUserResponse,
} from '../../types/lenders/ILenderUser';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const getLenderUsersAsync = async (lenderId: string): Promise<ILenderUserData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ILenderUserResponse[]>(`/timber/api/internal/lender_companies/${lenderId}/lender_users`)
    .then((response) => convertFromLenderUserResponseArrayToLenderUserDataArray(response.data))
    .catch((e: AxiosError) => {
      if (e.response && e.response.status === 404) {
        return Promise.resolve([]);
      } else {
        return axiosErrorHandler(e);
      }
    });

export const addLenderUsersAsync = async ({ lenderId, contact }: { lenderId: string; contact: ILenderUserData }) =>
  APIFactory(baseUrlService.ApiLocation)
    .post<ILenderUserResponse>(
      `/timber/api/internal/lender_companies/${lenderId}/lender_users`,
      convertFromLenderUserDataToLenderUserResponse(contact)
    )
    .catch(axiosErrorHandler);

export const editLenderUsersAsync = async ({ lenderId, contact }: { lenderId: string; contact: ILenderUserData }) =>
  APIFactory(baseUrlService.ApiLocation)
    .put<ILenderUserResponse>(
      `/timber/api/internal/lender_companies/${lenderId}/lender_users/${contact.id}`,
      convertFromLenderUserDataToLenderUserResponse(contact)
    )
    .catch(axiosErrorHandler);

export const actionLenderUsersAsync = async ({
  lenderId,
  contactId,
  actionType,
}: {
  lenderId: string;
  contactId: string;
  actionType: eClientContactActionType;
}) => {
  return APIFactory(baseUrlService.ApiLocation)
    .patch<ILenderUserResponse>(
      `/timber/api/internal/lender_companies/${lenderId}/lender_users/${contactId}/${actionType.toLowerCase()}`
    )
    .catch(axiosErrorHandler);
};
